import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    throw new Error(body?.message || 'Request failed')
  }
  return body.data
}

export type PaystackAutoWithdraw = 'off' | 'daily' | 'weekly' | 'monthly'

export type PaystackPayoutStatus = {
  storeId: number
  recipientCode: string | null
  bankCode: string | null
  accountNumberLast4: string | null
  accountName: string | null
  recipientActive: boolean
  autoWithdraw: PaystackAutoWithdraw
  autoWithdrawAnchorAt: string | null
  readyForPayout: boolean
  currencyEligible: boolean
  paystackConfigured: boolean
}

export type PaystackBank = { name: string; code: string; currency: string }

export async function fetchPaystackPayout(storeId: number): Promise<PaystackPayoutStatus> {
  const { data } = await api.get(`/storebusiness/stores/${storeId}/paystack/payout`)
  return assertSuccess(data) as PaystackPayoutStatus
}

export async function fetchPaystackBanks(storeId: number): Promise<PaystackBank[]> {
  const { data } = await api.get(`/storebusiness/stores/${storeId}/paystack/banks`)
  const payload = assertSuccess(data) as { banks: PaystackBank[] }
  return payload.banks ?? []
}

export async function resolvePaystackAccount(
  storeId: number,
  body: { bankCode: string; accountNumber: string },
): Promise<{ accountNumber: string; accountName: string }> {
  const { data } = await api.post(`/storebusiness/stores/${storeId}/paystack/resolve-account`, body)
  return assertSuccess(data) as { accountNumber: string; accountName: string }
}

export async function savePaystackRecipient(
  storeId: number,
  body: { bankCode: string; accountNumber: string; accountName?: string },
): Promise<PaystackPayoutStatus> {
  const { data } = await api.post(`/storebusiness/stores/${storeId}/paystack/recipient`, body)
  return assertSuccess(data) as PaystackPayoutStatus
}

export async function updatePaystackAutoWithdraw(
  storeId: number,
  schedule: PaystackAutoWithdraw,
): Promise<PaystackPayoutStatus> {
  const { data } = await api.patch(`/storebusiness/stores/${storeId}/paystack/auto-withdraw`, {
    schedule,
  })
  return assertSuccess(data) as PaystackPayoutStatus
}
